
import { DatatableConfig, DatatableInstance, DatatableMixin } from '@vedicium/metronic-vue';
import { DatatableUtil } from '@vedicium/vue-core';
import Vue from 'vue';
import { CONFIRMATION_MODAL_EVENT_OPEN } from '../../../../components/layout/portal/modals';
import { Core } from '../../../../services/core';
import { LightSourcePartEntity, LightSourcePartsStore } from '../../../../services/parts';

export default Vue.extend({
  name: 'partsLightSourcesOverview',
  mixins: [DatatableMixin],
  data() {
    return {
      datatable: {
        url: LightSourcePartsStore.url,
        fields: [
          {
            name: 'description',
            title: 'Description',
            sortField: 'description',
            titleClass: 'w-200px',
            dataClass: 'w-200px',
          },
          {
            name: 'article_number',
            title: 'Article number',
            sortField: 'article_number',
            titleClass: 'w-200px',
            dataClass: 'w-200px',
          },
          {
            name: 'type',
            title: 'Type',
            sortField: 'type',
            titleClass: 'w-100px',
            dataClass: 'w-100px',
            formatter: (value: string) => this.$t(`parts.light_sources.types.${value}`),
          },
          {
            name: 'light_source_code',
            title: 'Code',
            titleClass: 'w-200px',
            dataClass: 'w-200px',
          },
          {
            name: 'marking',
            title: 'Marking',
            titleClass: 'w-200px',
            dataClass: 'w-200px',
          },
          {
            name: 'actions',
            title: 'Actions',
            titleClass: 'w-100px',
            dataClass: 'w-100px',
          },
        ],

        sort: [{ field: 'description', direction: 'asc' }],
        searchFields: ['description', 'article_number'],

        fetch: DatatableUtil.fetch(Core),
      } as DatatableConfig,
    };
  },

  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([
      { title: 'Parts', route: '/parts' },
      { title: 'Light sources', route: '/parts/light-sources' },
    ]);
  },

  methods: {
    removeLightSource(entity: LightSourcePartEntity): void {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      vm.$metronic.eventhub.emit(CONFIRMATION_MODAL_EVENT_OPEN, {
        title: 'Remove light source',
        message: `Are you sure that you want to delete the light source <strong>${entity.description}</strong>?<br />Please type the name of the light source to confirm:`,
        verifyString: entity.description,
        async onSubmit() {
          await LightSourcePartsStore.delete(entity._meta.guid, { persistent: true });

          (vm.$refs.datatable as DatatableInstance).reload();
        },
      });
    },
  },
});
